import * as C from './PageMeta.const';
import * as T from './PageMeta.types';

// получает заголовок и описание на основе урла
export const getMetaInfo = (url: string): T.MetaProps => {
  const key = url as keyof typeof C.metaMap;

  const { title, description, image, canonicalHref } = C.metaMap[key] || {
    title: C.defaultMeta.title,
    description: C.defaultMeta.description,
    image: C.defaultMeta.image,
    canonicalHref: C.defaultMeta.canonicalHref,
  };

  return {
    title,
    description,
    image,
    canonicalHref,
  };
};

export const replacePlaceholders = (inputString: string, valueObject: any) => {
  const placeholderRegex = /%([^%]+)%/g;

  return inputString?.replace(placeholderRegex, (match, placeholder) =>
    valueObject.hasOwnProperty(placeholder) ? valueObject[placeholder] : match
  );
};
